export default "__VITE_ASSET__BsK1UNVT__"